import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const polarisProductViewBlueprintsSettingsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-polaris-settings-view-blueprints", jiraSpaEntry: "async-polaris-ideas" */ './src/PolarisViewBlueprintsSettingsPage'
			),
	),
	getPreloadProps: () => ({}),
});
